import { GetActivosByFiltersDtoProps } from "api/DTOs/GetActivosByFiltersDto"
import { TFunction } from "i18next"
import { frontendCurrency } from "utils/formatCurrency"
import { frontendDateFormat } from "utils/formatDate"
import { EstadoActivos } from "../components/EstadoActivos"
import { NombreCuentaContable } from "../components/NombreCuentaContable"

export const ACTIVOS_COLUMNS = (t: TFunction) => {
  const columns = [
    {
      header: t("nsAssets.mainTable.id"),
      field: "identificador",
      key: "identificador",
      style: { width: "5%" },
      sortable: true,
      sortField: "identificador",
      body: ({
        cuentaContable,
        identificador,
      }: GetActivosByFiltersDtoProps) => {
        return `AF${cuentaContable?.numero ?? ""}${identificador ?? ""}`
      },
    },
    {
      header: t("nsAssets.mainTable.name"),
      field: "nombre",
      key: "nombre",
      style: { width: "19%" },
      sortable: true,
      sortField: "nombre",
    },
    {
      header: t("nsAssets.mainTable.acquisitionDate"),
      field: "fechaAdquisicion",
      key: "fechaAdquisicion",
      style: { width: "5%" },
      sortable: true,
      sortField: "fechaAdquisicion",
      body: ({ fechaAdquisicion }: GetActivosByFiltersDtoProps) => {
        return fechaAdquisicion
          ? frontendDateFormat(new Date(fechaAdquisicion))
          : ""
      },
    },
    {
      header: t("nsAssets.mainTable.price"),
      field: "importe",
      key: "importe",
      style: { width: "5%" },
      sortable: true,
      sortField: "importe",
      className: "!tw-text-end",
      alignCol: "right",
      body: ({ importe }: GetActivosByFiltersDtoProps) => {
        return frontendCurrency(importe ?? 0)
      },
    },
    {
      header: t("nsAssets.mainTable.status"),
      field: "estado",
      key: "estado",
      style: { width: "8%" },
      sortable: true,
      sortField: "estado",
      className: "!tw-text-center",
      alignCol: "center",
      body: ({ estado }: GetActivosByFiltersDtoProps) =>
        EstadoActivos({ variant: estado, t }),
    },
    {
      header: t("nsAssets.mainTable.netValue"),
      field: "valorNeto",
      key: "valorNeto",
      style: { width: "10%" },
      className: "!tw-text-end",
      alignCol: "right",
      body: ({ valorNeto }: GetActivosByFiltersDtoProps) => {
        return frontendCurrency(valorNeto ?? 0)
      },
    },
    {
      header: t("nsAssets.mainTable.accumulatedAmortization"),
      field: "amortizado",
      key: "amortizado",
      style: { width: "8%" },
      className: "!tw-text-end",
      alignCol: "right",
      body: ({ amortizado }: GetActivosByFiltersDtoProps) => {
        return frontendCurrency(amortizado ?? 0)
      },
    },
    {
      header: t("nsAssets.mainTable.accountingAccount"),
      field: "cuentaContable",
      key: "cuentaContable",
      style: { width: "17%" },
      sortable: true,
      sortField: "cuentaContable.numero",
      className: "!tw-text-end",
      alignCol: "right",
      body: ({ cuentaContable }: GetActivosByFiltersDtoProps) =>
        NombreCuentaContable({
          cuentaContableId: cuentaContable?.id,
          cuentaContableLabel: cuentaContable?.numero,
        }),
    },
  ]
  return columns
}
